import type { IPortalClient } from "./iPortalClient";
import { ChannelsClient } from "../domains/channels/channels.client";
import { ServiceClient } from "../domains/service/service.client";
import { DriversClient } from "../domains/drivers/drivers.client";
import { FiltersClient } from "../domains/filters/filters.client";
import { LisClient } from "../domains/lis/lis.client";
import { SamplesClient } from "../domains/samples/samples.client";
import { PendingClient } from "../domains/pending/pending.client";
import { TestsClient } from "../domains/tests/tests.client";

export class ProdCoreClient implements IPortalClient {
  channels: ChannelsClient;
  service: ServiceClient;
  drivers: DriversClient;
  filters: FiltersClient;
  lis: LisClient;
  samples: SamplesClient;
  pending: PendingClient;
  tests: TestsClient;

  constructor(baseUrl: string, token: string | null) {
    this.channels = new ChannelsClient(baseUrl, token);
    this.service = new ServiceClient(baseUrl, token);
    this.drivers = new DriversClient(baseUrl, token);
    this.filters = new FiltersClient(baseUrl, token);
    this.lis = new LisClient(baseUrl, token);
    this.samples = new SamplesClient(baseUrl, token);
    this.pending = new PendingClient(baseUrl, token);
    this.tests = new TestsClient(baseUrl, token);
  }
}
